"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M18.871 21.827V5.098L4 7.112v14.715h14.871zM4 24.461v12.392l14.871 2.788v-15.18H4zm17.504 0v15.645l22.306 4.182V24.461H21.504zm22.306-2.634V2L21.504 4.788v17.039H43.81z" })
);

